
<kendo-scheduler
  [kendoSchedulerBinding]="items"
  [modelFields]="eventFields"
  scrollTime="08:00"
  [weekStart]="1"
  style="height: 100%;"
  (slotDblClick)="slotDblClickHandler($event)"
  (eventDblClick)="eventDblClickHandler($event)"
>
  <!-- <kendo-scheduler-day-view></kendo-scheduler-day-view> -->
  <kendo-scheduler-week-view [allDaySlot]="false" startTime="06:00" endTime="20:00" workDayStart="08:00" workDayEnd="19:00" workWeekStart="1" workWeekEnd="5"></kendo-scheduler-week-view>
  <kendo-scheduler-month-view></kendo-scheduler-month-view>
  <!-- <kendo-scheduler-timeline-view></kendo-scheduler-timeline-view> -->
  <kendo-scheduler-agenda-view></kendo-scheduler-agenda-view>
  <kendo-scheduler-year-view></kendo-scheduler-year-view>
</kendo-scheduler>
